export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/60">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-50 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-500"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">移动端随时随地阅读</h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-[600px]">
              UU漫画支持手机、平板等移动设备<strong>在线免费阅读</strong>，无需下载APP，浏览器打开即可畅享<strong>免费漫画全集</strong>。自适应屏幕尺寸，竖屏阅读体验流畅，横屏双页模式更接近纸质漫画的阅读感受，让你随时随地沉浸在<strong>免费漫画资源</strong>的世界里。
            </p>
          </div>
          <a
            href="#updates"
            className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
            查看最新更新
          </a>
        </div>
      </div>
    </section>
  );
}